import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { getAccountsPayableAgingReport } from "../../../../services/finance/financeReportService";
import Illustration from "../../../../partials/content/Illustration";

function AccountsPayableAging(props) {
  const { reload } = useGlobalData();
  const [payableAgingList, setPayableAgingList] = useState([]);
  useEffect(() => {
    getAccountsPayableAgingData();
  }, [reload]);
  return (
    <React.Fragment>
      {payableAgingList.length ? (
        <React.Fragment>
          <CustomDataTable
            data={payableAgingList}
            onRefreshData={() => {
              getAccountsPayableAgingData();
            }}
            columns={[
              {
                header: "Vendor Name",
                field: "vendorName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis text={rowData.vendorName} maxLine="1" />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Current",
                field: "currentAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.currentAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "1 - 30 Days",
                field: "thirtyDayAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.thirtyDayAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "31 - 60 Days",
                field: "sixtyDayAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.sixtyDayAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "61 - 90 Days",
                field: "ninetyDayAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.ninetyDayAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Over 90 Days",
                field: "overNinetyDayAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.overNinetyDayAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Total",
                field: "payableAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.payableAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Payment.png"
            description="You don't have any Accounts Payable data yet"
            guidance="Hint: once the Vendor is created, it will be displayed here"
            descriptionLeftIcon="fas fa-info-circle kt-font-info"
            size="md"
          ></Illustration>
        </React.Fragment>
      )}
    </React.Fragment>
  );

  async function getAccountsPayableAgingData() {
    const response = await getAccountsPayableAgingReport();
    const { data } = response.data;
    setPayableAgingList(data.payableAgingList);
  }
}

export default AccountsPayableAging;
